module.exports = __webpack_public_path__ + "img/zps.e3b9383e.png";